import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { Countdown } from '../Countdown';
import { ScarcityBar } from '../ScarcityBar';
const includes = ['6 premium volumes', '5 professional bonuses', '30+ protocols & checklists', 'Case trackers', 'Quick reference cards', 'Planning & review tools'];
export function FinalCTA() {
  return <section className="w-full bg-navy-900 py-14 sm:py-20" data-id="element-154" data-mp="3dtc1jghcw25g">
      <div className="mx-auto flex w-full max-w-3xl flex-col items-center px-4 text-center" data-id="element-155" data-mp="3dv6loskszq8h">
        <p className="text-xs font-extrabold uppercase tracking-[0.18em] text-sky-400" data-id="element-156" data-mp="3hw09zn25r71w">
          🚨 Last call
        </p>
        <h2 className="mt-3 font-display text-[26px] font-black uppercase leading-[1.1] text-white sm:text-4xl" data-id="element-157" data-mp="38tzd4rau6n0r">
          Stop relying on memory to organize your aligner cases
        </h2>
        <p className="mt-4 max-w-2xl text-base leading-relaxed text-navy-100" data-id="element-158" data-mp="121q6nvbzp52g">
          You don’t need another document full of information. You need a
          practical way to organize what you already know and structure the
          workflow around each case.
        </p>

        <ul className="mt-8 grid w-full grid-cols-1 gap-2 sm:grid-cols-2" data-id="element-159" data-mp="l9aah9jvqkio">
          {includes.map(item => <li key={item} className="flex items-center gap-2 rounded-xl bg-white/[0.07] px-3 py-2.5 text-left text-sm font-bold text-white" data-id="element-160" data-mp="z31jmgtp82dv">
              <CheckIcon className="h-4 w-4 shrink-0 text-sky-400" aria-hidden="true" data-id="element-161" data-mp="7a17jbkopmwn" />
              {item}
            </li>)}
        </ul>

        <p className="mt-8 font-display text-5xl font-black leading-none text-white sm:text-6xl" data-id="element-162" data-mp="gc0m7x888ewf">
          $27
        </p>
        <p className="mt-1 text-sm font-extrabold uppercase tracking-wide text-sky-400" data-id="element-163" data-mp="bdpfvwh54miy">
          One-time payment · Automatic currency conversion
        </p>

        <div className="mt-6 flex w-full flex-col items-center gap-5" data-id="element-164" data-mp="1mpq8xnl1ex4i">
          <CTAButton label="Get Aligner Control System™" subline="One-time payment · Lifetime access · Instant digital access · 7-day guarantee" data-id="element-165" data-mp="kdn1n4m6k6la" />
          <Countdown tone="light" data-id="element-166" data-mp="te1ls0nerfn7" />
          <ScarcityBar data-id="element-167" data-mp="teuxlg184vc7" />
        </div>
      </div>
    </section>;
}